export const styles = {
    container: {
        position: 'relative'
    },
    iframe: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zoom: 1.25
    },
    loadingSpinnerContainer: {
        position: 'relative'
    },
    loadingSpinnerChild: {
        position: 'absolute',
        transform: 'translate3d(-50%, -50%, 0)'
    }
};
